import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";

import rootReducer from "./reducers";
import { Provider } from "react-redux";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  process.env.REACT_APP_ENVIRONMENT == "development"
    ? composeEnhancers(applyMiddleware(thunk))
    : applyMiddleware(thunk)
);

function DataProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
export default DataProvider;
